// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { blankSelectItem } from "#/admin/legacy/sp-select/index.js";

/** Returns the shared-component filter items: the server's type and behavior items, and the labels after a "No filter" placeholder. */
export function sharedComponentFilterItems(labels, filterItems) {
  const noFilter = {
    ...blankSelectItem(),
    title: globalThis.Sparkle.t("admin.components.messages.no_filter"),
  };

  return {
    labelItems: [
      noFilter,
      ...labels.map((label) => ({
        title: label.name,
        value: String(label.id),
        dataset: {},
      })),
    ],
    typeItems: filterItems.type,
    behaviorItems: filterItems.behavior,
  };
}
